import React from 'react';

import './WidgetCard.scss';

const WidgetCard = (props) => {
    const className = 'widget-card' + (props.active ? ' active' : '');
    return (
        <div 
        	className={className} 
        	onClick={() => props.onClick(props.item.id)} 
        	style={{width: props.width+'px', height: props.height+'px'}}>
	        <div>
	            {props.item.icon && <i className={`fa ${props.item.icon}`} />}
	            <h4>{props.item.name}</h4>
	        </div>
	    </div>
    );
};

WidgetCard.propTypes = {
    item: React.PropTypes.object,
    onClick: React.PropTypes.func,
    active: React.PropTypes.bool,
};

export default WidgetCard;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/WidgetCard/WidgetCard.jsx
 **/